import * as React from 'react';

export abstract class BaseComponent<TProps = {}, TState = {}> extends React.Component<TProps, TState>
{
    public state: TState = {} as TState;
    public isMounted: boolean;

    constructor(props: TProps, context: any)
    {
        super(props, context);
        // nix built in deprecated warning throwing property with our own
        Object.defineProperty(this, 'isMounted', { writable: true, value: false });
    }

    public componentWillUnmount(): void
    {
        this.isMounted = false;
    }

    public componentDidMount(): void
    {
        this.isMounted = true;
    }
}